import React, { useContext, useState } from 'react';
import { globalStore } from '../state/store';
import theme from '../theme/theme';
import AvatarEditor from 'react-avatar-editor';
import { Avatar, Box, Button, CircularProgress,
     Grid, IconButton, InputAdornment, Slider, Stack, 
     TextField, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faCheckCircle, faEnvelope, faMagnifyingGlassMinus, faMagnifyingGlassPlus, faTag, faUser } from '@fortawesome/free-solid-svg-icons';
import { updateUser } from '../services/userService';

import defaultAvatar from '../assets/img/defaultAvatar.png'
import CircularProgressCP from './CircularProgressCP';

const CompleteAccount = (props) => {
  const styles = {
    resizeBox: { 
        [theme.breakpoints.only('xs')]: { width: '320px' },
        [theme.breakpoints.up('sm')]: { width: '480px' },
        marginBottom: '20px',
    },
  }

  const isValid = (field, newVal) => {
    const isValid = 
        (field === 'full' && Boolean(newVal) && newVal.length >= 3 && newVal.length <= 30) ||
        (field === 'nick' && Boolean(newVal) && newVal.length >= 3 && newVal.length <= 30) 
    return isValid
  }

  const [state, dispatch] = useContext(globalStore);
  const [loading, setLoading] = React.useState(false)
  const [scale, setScale] = React.useState(1.0)
  const [fullName, setFullName] = React.useState({valid: isValid('full', state.user.displayName), value: Boolean(state.user) && Boolean(state.user.displayName) ? state.user.displayName : ''});
  const [nickName, setNickName] = React.useState({valid: isValid('nick', state.user.nickName), value: Boolean(state.user) && Boolean(state.user.nickName) ? state.user.nickName : ''});

  const handleSubmit = () => {
    setLoading(true)
    console.log("state.user",state.user)
    const newUser = {
        uid: state.user.uid,
        email: state.user.email,
        displayName: fullName.value,
        nickName: nickName.value,
        photoURL: state.user.photoURL, // todo - new upload
        creationDate: state.user.creationDate,
    }

    console.log("newUser", newUser)
    updateUser(newUser) // proceed to update
    .then((resU) => { // once updated, navigate

      dispatch({ type: "INIT_USER", payload: newUser });
      setLoading(false)

    }).catch((err) => {
        console.log("err1x", err) 
        setLoading(false)
        // TODO snackbar
    })

    console.log(newUser)

  }

  return (
    <Grid container direction="column" justifyContent="center" alignItems="center" style={{margin: '25px 0px 25px 0px'}}>
        {loading ?
        <Grid item sx={{margin: '80px 0px 30px 0px'}}>
            <CircularProgressCP />
        </Grid>
        : 
        <Grid item container direction="column" alignItems="center" >
            <Grid item>
                <Typography variant="h4" align="center" sx={{mb: 3}}>
                Welcome<span style={{color: theme.palette.primary.main}}>.</span>
                </Typography>
                <Typography sx={{mb: 0}}>Complete your Cup Predictor account:</Typography>
            </Grid>
            <Grid item sx={styles.resizeBox} style={{marginBottom: '0px'}}>
                <Grid container justifyContent={"center"} alignItems={"center"}>
                    <Grid item sx={6} /*style={{backgroundColor: '#ff0000', margin: '-30px'}}*/>
                    <AvatarEditor
                    image={Boolean(state.user.photoURL) ? state.user.photoURL : defaultAvatar}
                    width={120}
                    height={120}
                    border={60}
                    borderRadius={60}
                    color={[255, 255, 255, 0.7]} // RGBA
                    scale={scale}
                    rotate={0}
                    />
                    </Grid>
                    <Grid item sx={6}>
                        <Button>
                            Upload profile photo
                        </Button>
                        <Stack spacing={2} direction="row" sx={{ alignItems: 'center', mb: 1}}>
                        <Slider aria-label="Scale"
                        min={1} max={2} step={0.2} value={scale} onChange={(e, newVal) => setScale(newVal)} />
                        </Stack>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item sx={styles.resizeBox}>
                <TextField
                //autoFocus
                fullWidth
                variant="outlined"
                id="displayName"
                placeholder={"Your full name..."}
                label="Full name"
                name="displayName"
                autoComplete="displayName"
                value={fullName.value}
                onChange={e => setFullName({valid: isValid('full', e.target.value), value: e.target.value})}
                InputProps={{
                  startAdornment: (
                  <InputAdornment position="start">
                      <FontAwesomeIcon 
                      icon={faUser} 
                      color={theme.palette.primary.main} />
                  </InputAdornment>
                  ),
                  endAdornment: fullName.valid ? (
                    <InputAdornment position="end">
                        <FontAwesomeIcon icon={faCheckCircle} 
                        style={{fontSize: '20px', marginRight: '5px', 
                                color: theme.palette.success.main}} />
                    </InputAdornment>
                  ) : null
                }}
                />
            </Grid>
            <Grid item sx={styles.resizeBox}>
                <TextField
                //autoFocus
                fullWidth
                variant="outlined"
                id="nickName"
                placeholder={"Your nickname..."}
                label="Nickname"
                name="nickName"
                autoComplete="nickName"
                value={nickName.value}
                onChange={e => setNickName({valid: isValid('nick', e.target.value), value: e.target.value})}
                //onChange={e => handleEmailUpdate(e.target.value.toLowerCase())}
                InputProps={{
                    startAdornment: (
                    <InputAdornment position="start">
                        <FontAwesomeIcon 
                        icon={faTag} 
                        color={theme.palette.primary.main} />
                    </InputAdornment>
                    ),
                    endAdornment: nickName.valid ? (
                        <InputAdornment position="end">
                            <FontAwesomeIcon icon={faCheckCircle} 
                            style={{fontSize: '20px', marginRight: '5px', 
                                    color: theme.palette.success.main}} />
                        </InputAdornment>
                    ) : null
                }}
                />
            </Grid>
            <Grid item sx={styles.resizeBox}>
              <Button
                onClick={handleSubmit}
                type="submit"
                disableElevation
                variant="contained"
                fullWidth
                disabled={!fullName.valid || !nickName.valid || loading}
                style={{padding: '5px 15px', fontWeight: '600', fontSize: '17px', marginBottom: '5px'}}>
                {loading ?
                <>Saving...&nbsp;&nbsp;<CircularProgress size={15} /></>
                :<>Save & Proceed&nbsp;&nbsp;<FontAwesomeIcon icon={faArrowRight} /></>}
              </Button>
            </Grid>
        </Grid>
        }

    </Grid>
  );
};
export default CompleteAccount;